import type { SimpleGridProps as _SimpleGridProps } from "@chakra-ui/react";
import { SimpleGrid as _SimpleGrid, forwardRef } from "@chakra-ui/react";

export interface SimpleGridProps extends _SimpleGridProps {}

export const SimpleGrid = forwardRef<SimpleGridProps, "div">(({ ...props }, ref) => (
    <_SimpleGrid ref={ref} {...props} />
));
